// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-namespace */
import { dateUtil, deviceUtil, logUtil, pageUtil } from "@repo/lib-common";
import { AdLoadingStrategyTypeEnum, AdUnit, AdUnitSpecialUseCaseEnum, AdUnitTypeEnum } from "./adUnit";

import { AdUnitMap, GptSlot, TargetingMap } from "./googleTypes";
import { pbjs_BidderSettings, pbjsConfig_ConsentManagement, pbjsConfig_Default, pbjsConfig_GvlMapping } from "./pbjsConfigs";
import { PbjsAdUnit } from "./pbjsTypes";
import { objUtil } from "@repo/lib-common";
//import { domContentLoadedSubject } from "../eventSubjects/domContentLoadedSubject";
import { tcfReadySubject } from "../eventSubjects/tcfReadySubject";
import { firstSlotRenderEndedSubject } from "./eventSubjects/firstSlotRenderEndedSubject";
import { SlotRenderEndedSubjectData } from "./eventSubjects/slotRenderEndedSubject";
import { AdsConf } from "../../global";
import { PageClientSubjectData, pageClientExecutionEndedSubject } from "../eventSubjects/pageClientExecutionEndedSubject";



const uuidStr = objUtil.uuidStr;


const PREBID_TIMEOUT = 1000;
const PREBID_FAILSAFE_TIMEOUT = 2000;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-var
declare var pbjs: any;

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-var
declare var apstag: any;

/** req manager for aps and prebid **/
export class RequestManager {
    adserverRequestSent = false;
    aps = false;
    prebid = false;
    err_pbjsRequestIds_AlreadExists = false;
    err_pbjsResponseIds_AlreadExists = false;
    correlationId!: string;
}
/** page main builder class contains ad units and targeting */
export abstract class PageAdsBuilder {

    constructor(deviceType: deviceUtil.DeviceTypeEnum, pageType: pageUtil.PageTypeEnum) {
        this.pageType = pageType;
        this.deviceType = deviceType;
        this.indexer = `${this.deviceType}-${this.pageType}`
        if (!this.isEnabled) return;
        this.init();
    }
    abstract init(): void;
    deviceType: deviceUtil.DeviceTypeEnum;
    pageType: pageUtil.PageTypeEnum;
    isEnabled: boolean = true;
    indexer: string;
    targeting: TargetingMap = {};
    adUnits: AdUnitMap = {};



    //#region auto refresh
    isAutoRefreshEnabled = false;
    isAutoRefreshRunning = false;
    autoRefreshIntervalInMs = 45 * 1000;
    autoRefreshRefId?: number;
    adsConf?: AdsConf
    setAdsConfAndApply(val: AdsConf) {
        this.adsConf = val;
        //check if adsConf exists -->
        if (this.adsConf) {
            logUtil.consoleLog("custom adsConf has been applied", this.adsConf)
            this.isEnabled = this.adsConf.isEnabled;
            this.mergeTargetingMap(this.adsConf.targetingMap)
        }
        //check if adsConf exists -->

        return this;
    }


    setIsAutoRefreshEnabled(val: boolean) {
        this.isAutoRefreshEnabled = val;
        return this;
    }
    getIsAutoRefreshEnabled() {
        return this.isAutoRefreshEnabled;
    }
    //#endregion


    setIsEnabled(value: boolean): PageAdsBuilder {
        this.isEnabled = value;
        return this;
    }


    setTargeting(key: string, value: string): PageAdsBuilder {
        this.targeting[key] = value;
        return this;
    }

    mergeTargetingMap(targtingMap: TargetingMap): PageAdsBuilder {
        if (!targtingMap) return this;
        Object.keys(targtingMap).forEach(key => {
            this.targeting[key] = targtingMap[key];
        })
        return this;
    }

    setTargetingMap(targetingMap: TargetingMap): PageAdsBuilder {
        this.targeting = targetingMap;
        return this;
    }

    applyAdUnit(adUnit: AdUnit) {
        if (!adUnit.isEnabled) {
            return false;
        }
        adUnit.setDeviceType([this.deviceType])
        if (adUnit.build()) {
            this.adUnits[adUnit.divId] = adUnit;
            return true;
        }
        logUtil.consoleError("adUnit could not be initialized", adUnit)

    }

    getAdUnitByDivId(divId: string): AdUnit {
        return this.adUnits[divId];
    }

    private outPageAdUnitTypes = [
        AdUnitTypeEnum.outOfPage_BottomAnchor,
        AdUnitTypeEnum.outOfPage_Interstitial,
        AdUnitTypeEnum.outOfPage_TopAnchor,

    ];
    filterAdUnits(args?: {
        isPrebidEnabled?: boolean,
        adUnitType?: AdUnitTypeEnum,
        adUnitTypes?: Array<AdUnitTypeEnum>,
        loadingStrategy?: AdLoadingStrategyTypeEnum,
        loadingStrategies?: Array<AdLoadingStrategyTypeEnum>,
        excludeLoadingStrategies?: Array<AdLoadingStrategyTypeEnum>,
        specialUseCase?: AdUnitSpecialUseCaseEnum,
        specialUseCaseIndex?: number,
        allSpecialUseCases?: boolean,
        allOutOfPages?: boolean,
        isAutoRefreshEnabled?: boolean,
        divIds?: Array<string>,
        divId?: string,
        mustBeInitialized?: boolean,
        canBeRefreshed?: boolean,
        excludeDivIds?: Array<string>
    }) {
        return Object.entries(this.adUnits).filter(entry => {
            const adUnit = entry[1];
            if (!adUnit.isEnabled) return false;

            if (args?.adUnitType && args?.adUnitType !== adUnit.type) return false;
            if (args?.adUnitTypes && args.adUnitTypes.length > 0 && !args?.adUnitTypes.includes(adUnit.type)) return false;
            if (args?.loadingStrategy && args?.loadingStrategy !== adUnit.loadingStrategy) return false;
            if (args?.excludeLoadingStrategies && args?.excludeLoadingStrategies.includes(adUnit.loadingStrategy)) return false;
            if (args?.loadingStrategies && args?.loadingStrategies.length > 0 && !args.loadingStrategies.includes(adUnit.loadingStrategy)) return false;
            if (args?.isPrebidEnabled && args?.isPrebidEnabled !== adUnit.isPreBidEnabled) return false;
            if (args?.specialUseCase && args?.specialUseCase !== adUnit.specialUseCaseType) return false;
            if (args?.allSpecialUseCases && AdUnitSpecialUseCaseEnum.none === adUnit.specialUseCaseType) return false;
            if (args?.allOutOfPages && !this.outPageAdUnitTypes.includes(adUnit.type)) return false;
            if (args?.isAutoRefreshEnabled && args?.isAutoRefreshEnabled !== adUnit.isAutoRefreshEnabled) return false;
            if (args?.excludeDivIds && args.excludeDivIds.length > 0 && args.excludeDivIds.includes(adUnit.divId)) return false;
            if (args?.divId && args.divId !== adUnit.divId) return false;
            if (args?.divIds && !args.divIds.includes(adUnit.divId)) return false;
            if (args?.mustBeInitialized && args.mustBeInitialized !== adUnit.mustBeInitialized()) return false;
            //can be refreshed conditions -->
            if (args?.canBeRefreshed && !adUnit.canBeRefreshed()) return false;
            if (args?.canBeRefreshed && !this.intersectionObserver_VisibleDivIds.has(adUnit.divId)) return false;
            //can be refreshed conditions <--
            if (args?.specialUseCaseIndex && args?.specialUseCaseIndex !== adUnit.specialUseCaseIndex) return false;

            return true;

        }
        ).map(([, q]) => q);

    }

    updateAdUnit(adUnit: AdUnit) {
        this.adUnits[adUnit.divId] = adUnit;
    }

    //#region gpt -->
    gptWindowObject() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.googletag = window.googletag || { cmd: [] };
    }
    gptIsReady() {
        return window.googletag && googletag.apiReady && googletag.pubadsReady;

    }
    executeAsGptCommand(cmd: VoidFunction) {
        if (this.gptIsReady()) {
            cmd();
        } else {
            googletag.cmd.push(cmd);
        }
    }
    executeAsPbjsCommand(cmd: VoidFunction) {
        if (window.pbjs && pbjs.libloaded) {
            cmd();
        } else {
            pbjs.que.push(cmd);
        }
    }


    gptRefreshAdUnits(adUnits: Array<AdUnit>) {
        const slots = adUnits.filter(q => q.gptSlot).map(q => {
            q.gptState.isRefreshSlotExecuted = true;
            this.updateAdUnit(q);
            return q.gptSlot!
        });
        if (!slots || slots.length == 0) {
            logUtil.consoleWarn("gptRefreshAdUnits ad unit slots are empty", adUnits);
            return;
        }
        googletag.pubads().refresh(slots);
    }

    gptDisplayAdUnit(adUnit: AdUnit) {
        logUtil.consoleLog("GPT: display called adUnit.divId:", adUnit.divId);
        if (adUnit.type === AdUnitTypeEnum.banner && !document.getElementById(adUnit.divId)) {
            logUtil.consoleWarn(`GPT: display skipped - div not found in DOM: ${adUnit.divId}`);
            return;
        }
        adUnit.gptState.isDisplaySlotExecuted = true;
        if (adUnit.gptSlot) {
            googletag.display(adUnit.gptSlot);
        } else {
            logUtil.consoleWarn("GPT: display canceled because slot is undefined adUnit.divId:", adUnit.divId);
        }
        this.updateAdUnit(adUnit);
    }

    gptDisplayAdUnits(adUnits: Array<AdUnit>) {
        adUnits.forEach(adUnit => {
            this.gptDisplayAdUnit(adUnit);
        });
    }

    gptDefineSlot(adUnit: AdUnit) {
        logUtil.consoleLog("GPT: define slot called adUnit.divId:", adUnit.divId);
        if (adUnit.gptState.isDefineSlotExecuted && adUnit.gptSlot) {
            logUtil.consoleLog(`GPT: define slot already called for adUnit.divId:`, adUnit.divId);
            return;
        }

        adUnit.gptState.isDefineSlotExecuted = true;
        let gptSlot: GptSlot | null | undefined;
        if (adUnit.type === AdUnitTypeEnum.banner) {
            gptSlot = googletag.defineSlot(adUnit.adUnitPath, adUnit.sizes, adUnit.divId);
            if (gptSlot) {
                gptSlot.addService(googletag.pubads());
                gptSlot.setConfig({
                    collapseDiv: adUnit.isCollapseEmptyDivEnabled ? 'ON_NO_FILL' : 'DISABLED'
                } as any);
                if (adUnit.sizeMappings && adUnit.sizeMappings.length > 0) {
                    const gm = googletag.sizeMapping();
                    adUnit.sizeMappings.map(sm => {
                        gm.addSize(sm.viewport, sm.sizes);
                    });
                    const gmBuild = gm.build();
                    if (gmBuild) { gptSlot.defineSizeMapping(gmBuild!); }
                }


                logUtil.consoleLog(`gptSlot created for ${adUnit.adUnitPath}`);
                adUnit.setGptSlot(gptSlot);
            }

        } else if (adUnit.type === AdUnitTypeEnum.outOfPage_Interstitial) {
            //gptSlot = googletag.defineOutOfPageSlot(adUnit.adUnitPath, googletag.enums.OutOfPageFormat.INTERSTITIAL);
            gptSlot = googletag.defineOutOfPageSlot(adUnit.adUnitPath, adUnit.divId); //adm içindeki template'den dolayı bu şekilde olmalı
            if (gptSlot) {
                gptSlot.addService(googletag.pubads());
                logUtil.consoleLog(`gptSlot created for ${adUnit.adUnitPath}`);
                adUnit.setGptSlot(gptSlot);
            }
        } else if (adUnit.type === AdUnitTypeEnum.outOfPage_BottomAnchor) {
            gptSlot = googletag.defineOutOfPageSlot(adUnit.adUnitPath, googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR);
            if (gptSlot) {
                gptSlot.addService(googletag.pubads());
                logUtil.consoleLog(`gptSlot created for ${adUnit.adUnitPath}`);
                adUnit.setGptSlot(gptSlot);
            }
        } else if (adUnit.type === AdUnitTypeEnum.outOfPage_TopAnchor) {
            gptSlot = googletag.defineOutOfPageSlot(adUnit.adUnitPath, googletag.enums.OutOfPageFormat.TOP_ANCHOR);
            if (gptSlot) {
                gptSlot.addService(googletag.pubads());
                logUtil.consoleLog(`gptSlot created for ${adUnit.adUnitPath}`);
                adUnit.setGptSlot(gptSlot);
            }
        }
        if (!gptSlot) {
            logUtil.consoleError(`gptSlot could not be created for ${adUnit.adUnitPath}`);
        }
        this.updateAdUnit(adUnit);
    }

    gptEnableServices() {
        (googletag as any).setConfig({
            collapseDiv: 'DISABLED',
            disableInitialLoad: true,
            singleRequest: true,
        });
        googletag.enableServices();
    }

    gptSetTargeting() {
        if (!this.targeting || Object.keys(this.targeting).length === 0) return;
        (googletag as any).setConfig({
            targeting: { ...this.targeting }
        });
    }

    gptRegisterEvents() {
        this.executeAsGptCommand(() => {
            googletag.pubads().addEventListener("slotRenderEnded", (event: any): void => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:slotRenderEnded for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.setGptSlotRenderEndedEventData(event);
                    this.updateAdUnit(adUnit);
                }
                if (!firstSlotRenderEndedSubject.isTriggered) {
                    const firstData = new SlotRenderEndedSubjectData();
                    firstData.divId = elemId;
                    firstData.isEmpty = event.isEmpty;
                    firstSlotRenderEndedSubject.setDataAndTrigger(firstData);
                }
            });

            googletag.pubads().addEventListener("slotVisibilityChanged", (event: any) => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:slotVisibilityChanged for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.setGptSlotVisibilityChangedEventData(event);
                    this.updateAdUnit(adUnit);
                }
            });


            googletag.pubads().addEventListener("slotRequested", (event: any) => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:slotRequested for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.objectState.isProcessLockEnabled = true;
                    adUnit.setGptSlotRequestedEventData(event);
                    this.updateAdUnit(adUnit);
                }
            });
            googletag.pubads().addEventListener("slotResponseReceived", (event: any) => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:slotResponseReceived for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.objectState.isProcessLockEnabled = false;
                    adUnit.setGptSlotResponseReceivedEventData(event);
                    this.updateAdUnit(adUnit);
                }
            });

            googletag.pubads().addEventListener("impressionViewable", (event: any) => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:impressionViewable for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.setGptImpressionViewableEventData(event);
                    this.updateAdUnit(adUnit);
                }
            });
            googletag.pubads().addEventListener("slotOnload", (event: any) => {
                const slot = event.slot;
                const elemId = slot.getSlotElementId();
                logUtil.consoleLog(`"GPT:slotOnload for ${elemId}`, event);
                const adUnit = this.adUnits[elemId];
                if (adUnit) {
                    adUnit.setGptSlotOnloadEventData(event);
                    this.updateAdUnit(adUnit);
                }
            });
        });

    }

    //#endregion

    //#region pbjs -->
    private pbjsRequestIds = new Set<string>;
    private pbjsResponseIds = new Set<string>;


    pbjsWindowObject() {
        logUtil.consoleLog("pbjsWindowObject called");
        window.pbjs = window.pbjs || {};
        window.pbjs.que = window.pbjs.que || [];
    }

    pbjsSetDefaultConfig() {
        logUtil.consoleLog("pbjsSetDefaultConfig called");
        pbjs.setConfig(pbjsConfig_Default);
        pbjs.bidderSettings = pbjs_BidderSettings;
    }

    pbjsSetConfig(config: any) {
        logUtil.consoleLog("pbjsSetConfig called");
        this.executeAsPbjsCommand(() => {
            pbjs.setConfig(config);
        });
    }

    pbjsMergeConfig(config: any) {
        logUtil.consoleLog("pbjsMergeConfig called");
        this.executeAsPbjsCommand(() => {
            pbjs.mergeConfig(config);
        });

    }

    pbjsEnsureAdUnitsAdded(adUnits: Array<AdUnit>) {
        logUtil.consoleLog("pbjsAddAdUnits called", adUnits);
        if (adUnits && adUnits.length > 0) {
            const pbjsInternalAdUnitCodes = (pbjs.adUnits as PbjsAdUnit[]).map(q => q.code);
            const pbjsAdUnits = adUnits.filter(adUnit => !pbjsInternalAdUnitCodes.includes(adUnit.adUnitPath)).map(adUnit => {
                adUnit.pbjsState.isPbjsAdUnitAdded = true;
                this.updateAdUnit(adUnit);
                logUtil.consoleLog("pbjsAddAdUnits will add", adUnit);
                return adUnit.pbjsAdUnit;
            });
            if (pbjsAdUnits && pbjsAdUnits.length > 0) {
                pbjs.addAdUnits(pbjsAdUnits);
            }
        }
    }

    pbjsRefreshGptSlots(requestManager: RequestManager, correlationId: string, adUnitCodes: Array<string>, isFailSafeCall = false) {

        logUtil.consoleLog(`pbjsRefreshGptSlots called correlationId: ${correlationId}, isFailSafeCall:${isFailSafeCall} adUnits:`, adUnitCodes);
        if (!this.pbjsRequestIds.has(correlationId)) {
            this.pbjsRequestIds.add(correlationId);
            logUtil.consoleLog(`first use ${this.pbjsRefreshGptSlots.name}`);
            requestManager.err_pbjsRequestIds_AlreadExists = true;
            return;
        }
        if (this.pbjsResponseIds.has(correlationId)) {
            logUtil.consoleLog(`reqRes correlation id already exists ${correlationId} isFailSafeCall:${isFailSafeCall}`);
            requestManager.err_pbjsResponseIds_AlreadExists = true;
            return;
        }
        this.pbjsResponseIds.add(correlationId);
        //apstag -->
        if (requestManager.adserverRequestSent === true) {
            return;
        }
        requestManager.adserverRequestSent = true;
        //apstag --<
        this.executeAsGptCommand(() => {
            pbjs.setTargetingForGPTAsync();
            const slots = googletag.pubads().getSlots().filter(q => adUnitCodes.includes(q.getAdUnitPath()));
            logUtil.consoleLog("GPT slots:", slots);
            if (slots.length !== adUnitCodes.length) {
                logUtil.consoleError("adUnit codes and slots do not match", adUnitCodes);
            }
            googletag.pubads().refresh(slots);
        })
    }

    apstagRefreshSlots(requestManager: RequestManager, adUnitCodes: Array<string>, isFailSafeCall = false) {

        logUtil.consoleLog(`apstagRefreshSlots called correlationId: ${requestManager.correlationId}, isFailSafeCall:${isFailSafeCall} adUnits:`, adUnitCodes);
        if (!this.pbjsRequestIds.has(requestManager.correlationId)) {
            this.pbjsRequestIds.add(requestManager.correlationId);
            logUtil.consoleLog(`first use ${this.pbjsRefreshGptSlots.name}`);
            requestManager.err_pbjsRequestIds_AlreadExists = true;
            return;
        }
        if (this.pbjsResponseIds.has(requestManager.correlationId)) {
            logUtil.consoleLog(`reqRes correlation id already exists ${requestManager.correlationId} isFailSafeCall:${isFailSafeCall}`);
            requestManager.err_pbjsResponseIds_AlreadExists = true;
            return;
        }
        this.pbjsResponseIds.add(requestManager.correlationId);
        //apstag -->
        if (requestManager.adserverRequestSent === true) {
            return;
        }
        requestManager.adserverRequestSent = true;
        //apstag --<
        this.executeAsGptCommand(() => {
            apstag.setDisplayBids();
            const slots = googletag.pubads().getSlots().filter(q => adUnitCodes.includes(q.getAdUnitPath()));
            googletag.pubads().getSlots().forEach(q => console.log(q.getAdUnitPath()));
            if (slots.length !== adUnitCodes.length) {
                logUtil.consoleError("adUnit codes and slots do not match", adUnitCodes);
            }
            googletag.pubads().refresh(slots);
        })
    }

    public pbjsRequestBidsByPbjsAdUnits(adUnits: Array<AdUnit>) {
        logUtil.consoleLog("pbjsRequestBidsByPbjsAdUnits called", adUnits);
        if (adUnits === undefined || adUnits.length <= 0) {
            logUtil.consoleError(`${this.pbjsRequestBidsByPbjsAdUnits.name} canceled. adUnits are undefined or empty`);
            return;
        }

        const adUnitCodes = adUnits.map(adUnit => {
            adUnit.pbjsState.lastRequestedAt = dateUtil.dateTime.getTimeStamp();
            if (!adUnit.pbjsState.isPbjsInitialRequestExecuted) {
                adUnit.pbjsState.isPbjsInitialRequestExecuted = true;
            }
            this.updateAdUnit(adUnit);
            return adUnit.adUnitPath
        });

        const correlationId = uuidStr();
        this.pbjsRequestIds.add(correlationId);

        //apstag -->
        //pbjs.setTargetingForGPTAsync();
        const requestManager = new RequestManager();
        requestManager.correlationId = correlationId;
        //apstag --<


        // APS request -->
        const apsSlots = adUnits.filter(q => q.apsSlot).map(q => q.apsSlot);
        if (apsSlots && apsSlots.length > 0) {
            this.executeAsGptCommand(() => {
                apstag.fetchBids({
                    timeout: PREBID_TIMEOUT,
                    slots: apsSlots
                }, (bids: any) => {
                    logUtil.consoleLog(`apstag response for ${correlationId} => bids:`, bids);
                    googletag.cmd.push(() => {
                        apstag.setDisplayBids();
                        requestManager.aps = true; // signals that APS request has completed
                        this.apstagRefreshSlots(requestManager, adUnitCodes)
                    });
                }
                );
            })
        }

        // APS request --<

        this.executeAsPbjsCommand(() => {
            this.pbjsEnsureAdUnitsAdded(adUnits);

            logUtil.consoleLog(`request sent for ${correlationId}`);



            pbjs.requestBids({
                timeout: PREBID_TIMEOUT,
                adUnitCodes: adUnitCodes,
                bidsBackHandler: (bids?: any, timeOut?: boolean, auctionId?: string) => {
                    logUtil.consoleLog(`bisBackHandler response for ${correlationId} => timeOut:${timeOut}, auctionId:${auctionId}, bids:`, bids);
                    requestManager.prebid = true;
                    pbjs.setPAAPIConfigForGPT();
                    this.pbjsRefreshGptSlots(requestManager, correlationId, adUnitCodes);
                }
            });
            setTimeout(() => {
                this.pbjsRefreshGptSlots(requestManager, correlationId, adUnitCodes, true);
            }, PREBID_FAILSAFE_TIMEOUT);
        });

    }


    //#endregion


    //#region customLazyLoad -->
    private intersectionObserver_RootMargin = "400px"; //"0px"
    private intersectionObserver_VisibleIntersectionRatio = 0.50;
    private intersectionObserver_MinInterSectionRatio = 0.01;
    private intersectionObserver_Thresholds = [this.intersectionObserver_MinInterSectionRatio, this.intersectionObserver_VisibleIntersectionRatio];
    private intersectionObserver_Options = {
        root: null,
        //root:document.body,
        rootMargin: this.intersectionObserver_RootMargin,
        threshold: this.intersectionObserver_Thresholds,

    };


    intersectionObserver?: IntersectionObserver;
    intersectionObserver_VisibleDivIds = new Set<string>;

    initIntersectionObserver() {
        if (this.intersectionObserver) return;
        logUtil.consoleLog("initIntersectionObserver_ForLazyLoad called")

        //all ad units to track visibility -->
        const gptDivIds = this.filterAdUnits({ excludeLoadingStrategies: [AdLoadingStrategyTypeEnum.trigger] }).map(q => q.divId);
        //all ad units to track visibility --<
        if (gptDivIds && gptDivIds.length > 0) {
            this.intersectionObserver = new IntersectionObserver((entries) => {
                // if(!this.gptIsReady()){
                //     logUtil.consoleLog("intersectionObserver: GPT is not ready, will wait next intersection cycle");
                //     return;
                // }
                this.intersectionObserver_CallBack(entries);
            }, this.intersectionObserver_Options);
            gptDivIds.forEach(divId => {
                const elem = document.getElementById(divId);

                if (elem) {
                    this.intersectionObserver!.observe(elem);
                }
            })
        }

    }

    intersectionObserver_CallBack(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            const elemId = entry.target.id;
            if (entry.isIntersecting) {
                logUtil.consoleLog(`intersectionObserver: ${elemId} became visible intersectionRatio:  ${entry.intersectionRatio}`);
                if (this.intersectionObserver_VisibleDivIds.has(elemId)) {
                    //elem is already processed
                    return;
                }
                this.intersectionObserver_VisibleDivIds.add(elemId);

                //check adunits to be initialized
                // let filteredAdUnits = this.filterAdUnits({ divId: elemId, mustBeInitialized: true });
                // if (filteredAdUnits && filteredAdUnits.length > 0) {
                //     logUtil.consoleLog(`intersectionObserver: ${elemId} ad unit found to be initialized`);

                // } else {

                //     filteredAdUnits = this.filterAdUnits({ divId: elemId, canBeRefreshed: true });
                //     if (filteredAdUnits && filteredAdUnits.length > 0) {
                //         logUtil.consoleLog(`intersectionObserver: ${elemId} ad unit found to be refreshed`);
                //     } else {
                //         const adUnit = this.getAdUnitByDivId(elemId);
                //         logUtil.consoleLog(`intersectionObserver: ${elemId} ad unit is not available to be initialized/refreshed `, adUnit);
                //     }
                // }
                const filteredAdUnits = this.filterAdUnits({ divId: elemId, mustBeInitialized: true });
                logUtil.consoleLog(`intersectionObserver: ${elemId} ad unit found to be initialized`, filteredAdUnits);
                filteredAdUnits.forEach(adUnit => {

                    this.refreshOrInitializeAdUnit(adUnit);

                });

            } else {
                this.intersectionObserver_VisibleDivIds.delete(elemId);
                logUtil.consoleLog(`intersectionObserver: ${elemId} is not visible and will not be requested`)
            }
        });
    }

    //#endregion
    disableAndStopAutoRefresh() {
        this.setIsAutoRefreshEnabled(false);
        this.autoRefreshRefId && clearInterval(this.autoRefreshRefId);

    }
    applyDivStyles() {
        const adUnits = this.filterAdUnits({ excludeLoadingStrategies: [AdLoadingStrategyTypeEnum.trigger] });
        adUnits.forEach(adUnit => {
            adUnit.applyDivStyle();
        });
    }


    initAutoRefresh() {

        logUtil.consoleLog(`initAutoRefresh called autoRefreshIntervalInMs:`, this.autoRefreshIntervalInMs);

        if (this.isAutoRefreshEnabled && !this.autoRefreshRefId) {

            this.autoRefreshRefId = setInterval(() => {

                logUtil.consoleLog("autoRefresh triggered", new Date());
                if (!this.gptIsReady()) {
                    logUtil.consoleLog("autoRefresh: GPT is not ready, will wait next autoRefresh cycle");
                    return;
                }
                if (this.isAutoRefreshRunning) return;
                this.isAutoRefreshRunning = true;
                const filteredAdUnits = this.filterAdUnits({ canBeRefreshed: true });
                if (filteredAdUnits && filteredAdUnits.length > 0) {
                    logUtil.consoleLog(`autoRefresh: ad units found to refresh`, filteredAdUnits);
                    const pbjsAdUnits = filteredAdUnits.filter(q => q.isPreBidEnabled === true);
                    if (pbjsAdUnits && pbjsAdUnits.length > 0) {
                        logUtil.consoleLog(`autoRefresh: pbjsAdUnits to refresh`, pbjsAdUnits);
                        this.pbjsRequestBidsByPbjsAdUnits(pbjsAdUnits)
                    }
                    const gptAdUnits = filteredAdUnits.filter(q => q.isPreBidEnabled === false);
                    if (gptAdUnits && gptAdUnits.length > 0) {
                        logUtil.consoleLog(`autoRefresh: gptAdUnits to refresh`, gptAdUnits);
                        this.gptRefreshAdUnits(gptAdUnits)
                    }
                } else {
                    logUtil.consoleLog(`autoRefresh: ad units not found to refresh`);
                }

                this.isAutoRefreshRunning = false;
            }, this.autoRefreshIntervalInMs);
        }
    }

    refreshOrInitializeAdUnit(adUnit: AdUnit) {
        if (adUnit.objectState.isProcessLockEnabled) {
            logUtil.consoleLog('refreshOrInitializeAdUnit: adunit has proc lock and will not be refreshed', adUnit.divId, adUnit);
            return;
        }
        this.executeAsGptCommand(() => {
            adUnit.objectState.isProcessLockEnabled = true;
            //if prebid enabled adunit -->
            if (adUnit.isPreBidEnabled) {
                if (!adUnit.gptState.isDefineSlotExecuted || !adUnit.gptSlot) {
                    this.gptDefineSlot(adUnit);
                }
                logUtil.consoleLog('after gptDefineSlot', adUnit.divId, adUnit);
                if (!adUnit.gptState.isDisplaySlotExecuted) {
                    logUtil.consoleLog('in gptDisplayAdUnit', adUnit.divId, adUnit);
                    this.gptDisplayAdUnit(adUnit);
                }
                this.pbjsRequestBidsByPbjsAdUnits([adUnit]);

            }
            //if prebid enabled adunit <--
            //if prebid disabled adunit -->
            else {
                if (!adUnit.gptState.isDefineSlotExecuted) {

                    this.gptDefineSlot(adUnit);

                }
                if (!adUnit.gptState.isDisplaySlotExecuted) {
                    this.gptDisplayAdUnit(adUnit);
                }

                this.gptRefreshAdUnits([adUnit]);

            }
            //if prebid disabled adunit <--
            adUnit.objectState.isProcessLockEnabled = false;
            this.updateAdUnit(adUnit);
        });
    }

    isExecuteCompleted = false;
    execute() {

        try {
            logUtil.consoleLog("client execution started");
            if (!this.isEnabled) {
                logUtil.consoleLog("ads are disabled, client execution stopped");
                return;
            }




            tcfReadySubject.subscribe((tcData) => {
                if (tcData && tcData.gdprApplies) {
                    const newConf = pbjsConfig_Default;
                    newConf.consentManagement = pbjsConfig_ConsentManagement;
                    newConf.gvlMapping = pbjsConfig_GvlMapping;

                    this.pbjsMergeConfig(newConf);
                }
            });


            this.gptWindowObject();
            this.gptRegisterEvents();
            this.executeAsGptCommand(() => { this.gptSetTargeting(); });

            const singleRequestRequiredAdUnits = this.filterAdUnits({
                adUnitType: AdUnitTypeEnum.banner,
                loadingStrategy: AdLoadingStrategyTypeEnum.sra
            });

            //set states to avoid recurring request while waiting GPT to load/init in page. slotResponseReceived event will release lock.  -->
            singleRequestRequiredAdUnits.forEach(adUnit => {
                adUnit.objectState.isProcessLockEnabled = true;
                this.updateAdUnit(adUnit);
            });

            //set states to avoid recurring request while waiting GPT to load/init in page. slotResponseReceived event will release lock.  --<
            this.executeAsGptCommand(() => {
                //gpt define all sra ad units -->
                singleRequestRequiredAdUnits.forEach(adUnit => {
                    this.gptDefineSlot(adUnit);
                });
            });

            this.executeAsGptCommand(() => { this.gptEnableServices(); });


            //send request to pbjs if required -->
            const pbjsAdUnits = singleRequestRequiredAdUnits
                .filter(q => q.isPreBidEnabled && q.pbjsAdUnit);



            if (pbjsAdUnits && pbjsAdUnits.length > 0) {
                this.pbjsWindowObject();
                this.executeAsPbjsCommand(() => { this.pbjsSetDefaultConfig(); });
                this.executeAsGptCommand(() => {
                    this.gptDisplayAdUnits(pbjsAdUnits);
                });
                this.pbjsRequestBidsByPbjsAdUnits(pbjsAdUnits);
            }
            //send request to pbjs if required --<
            // call display and refresh for all gptSlots -->
            const gptAdUnits = singleRequestRequiredAdUnits
                .filter(q => !q.isPreBidEnabled);
            if (gptAdUnits && gptAdUnits.length > 0) {
                this.executeAsGptCommand(() => {
                    this.gptDisplayAdUnits(gptAdUnits);
                    this.gptRefreshAdUnits(gptAdUnits);
                });
            }
            document.addEventListener("readystatechange", () => {
                if (document.readyState === "complete") {
                    this.applyDivStyles();
                    this.initIntersectionObserver();
                }
            });

            // call display for all gptSlots --<
            document.addEventListener("DOMContentLoaded", () => {
                logUtil.consoleLog("client execution domContentLoadedSubject started");

                this.applyDivStyles();
                const preExecutedDivIds = singleRequestRequiredAdUnits && singleRequestRequiredAdUnits.length > 0 ? singleRequestRequiredAdUnits.map(q => q.divId) : [];
                //init domContentLoaded ads -->
                const domContentLoadAdUnits = this.filterAdUnits({
                    loadingStrategy: AdLoadingStrategyTypeEnum.domContentLoaded,
                    excludeDivIds: preExecutedDivIds
                });

                logUtil.consoleLog("domContentLoadAdUnits data:", domContentLoadAdUnits);
                if (domContentLoadAdUnits && domContentLoadAdUnits.length > 0) {
                    domContentLoadAdUnits.forEach(adUnit => {
                        preExecutedDivIds.push(adUnit.divId);
                        this.refreshOrInitializeAdUnit(adUnit);
                    });
                }
                //init domContentLoaded ads --<


                //init custom lazy loads -->
                this.initIntersectionObserver();
                //init custom lazy loads --<   


                //init outOfPAge ads -->
                setTimeout(() => {
                    const outOfPAgeAdUnits = this.filterAdUnits({
                        adUnitTypes: [AdUnitTypeEnum.outOfPage_Interstitial, AdUnitTypeEnum.outOfPage_BottomAnchor, AdUnitTypeEnum.outOfPage_TopAnchor],
                        excludeDivIds: preExecutedDivIds
                    });
                    logUtil.consoleLog("outOfPAgeAdUnits data:", outOfPAgeAdUnits);
                    if (outOfPAgeAdUnits && outOfPAgeAdUnits.length > 0) {
                        outOfPAgeAdUnits.forEach(adUnit => {
                            preExecutedDivIds.push(adUnit.divId);
                            this.refreshOrInitializeAdUnit(adUnit);
                        });
                    }
                }, 500);
                //init outOfPAge ads --<
                this.initAutoRefresh();


                logUtil.consoleLog("client execution domContentLoadedSubject finished");
                this.isExecuteCompleted = true;


            })

        } catch (error) {
            logUtil.consoleError(error);

        } finally {
            logUtil.consoleLog("client execution finished");
            document.addEventListener("DOMContentLoaded", () => {
                pageClientExecutionEndedSubject.setDataAndTrigger(new PageClientSubjectData());
            });
        }




    }


}


